export enum CategoriaEnum {
  NOVIDADES = 'NOVIDADES',
  DICAS = 'DICAS',
  RELEASE_NOTES = 'RELEASE_NOTES',
  WEBINAR = 'WEBINAR',
  COMUNICADOS = 'COMUNICADOS',
  CONTEUDO = 'CONTEUDO',
  OFERTAS = 'OFERTAS',
  INICIO = 'INICIO',
  INDIQUE = 'INDIQUE',
  COMPARTILHE_OPINIAO = 'COMPARTILHE_OPINIAO',
}

export interface CategoriaDefinicao {
  id: CategoriaEnum;
  nome: string;
  descricao: string;
  cor?: string;
  icone?: string;
  exibirApenasComDescricao?: boolean;
}

export const CATEGORIAS_INFO: { [key: string]: CategoriaDefinicao } = {
  INICIO: {
    id: CategoriaEnum.INICIO,
    nome: 'Início',
    descricao: '',
    icone: 'home'
  },
  NOVIDADES: {
    id: CategoriaEnum.NOVIDADES,
    nome: 'Novidades',
    descricao: 'Espaço para divulgação de melhorias recentes, Boletim de Evolução',
    cor: '#a461d8'
  },
  DICAS: {
    id: CategoriaEnum.DICAS,
    nome: 'Dicas',
    descricao: 'Insights rápidos em vídeo para orientar os usuários com informações úteis',
    cor: '#27ae60',
    exibirApenasComDescricao: true,
  },
  RELEASE_NOTES: {
    id: CategoriaEnum.RELEASE_NOTES,
    nome: 'Release Notes',
    descricao: 'Informações do que consta em cada atualização de versão do sistema',
    cor: '#6c7a89'
  },
  WEBINAR: {
    id: CategoriaEnum.WEBINAR,
    nome: 'Webinar',
    descricao: 'Webinar sobre melhorias e novas funcionalidades.',
    cor: '#8e44ad',
    exibirApenasComDescricao: true,
  },
  COMUNICADOS: {
    id: CategoriaEnum.COMUNICADOS,
    nome: 'Comunicados',
    descricao: 'comunicados técnicos de manutenção de ambiente, suporte, atendimento ao cliente',
    cor: '#29b6f6'
  },
  CONTEUDO: {
    id: CategoriaEnum.CONTEUDO,
    nome: 'Conteúdo',
    descricao: 'Informações de marketing, como webinars, vídeos de marketing, blog posts, etc ',
    cor: '#1abc9c',
    exibirApenasComDescricao: true,
  },
  OFERTAS: {
    id: CategoriaEnum.OFERTAS,
    nome: 'Ofertas',
    descricao: 'Condições promocionais comerciais',
    cor: '#e91e63'
  },
  INDIQUE: {
    id: CategoriaEnum.INDIQUE,
    nome: 'Indique e ganhe',
    descricao: '',
    cor: '#f2994a'
  },
  COMPARTILHE_OPINIAO: {
    id: CategoriaEnum.COMPARTILHE_OPINIAO,
    nome: 'Compartilhe sua opinião',
    descricao: '',
    cor: '#a6ffb2'
  }
};

//ids das paginas da base de conhecimento
export const MAPA_IDS_API: { [key: string]: { [key: string]: string } } = {
  maxMotorista: {
    NOVIDADES: '133988940',
    DICAS: '133988926',
    RELEASE_NOTES: '133988928',
    WEBINAR: '133988946',
    COMUNICADOS: '133988952',
    CONTEUDO: '31817760',
    OFERTAS: '133988938'
  },
  maxRoteirizador: {
    NOVIDADES: '133988940',
    DICAS: '133988942',
    RELEASE_NOTES: '133988944',
    WEBINAR: '133988946',
    COMUNICADOS: '133988952',
    CONTEUDO: '31817762',
    OFERTAS: '133988956'
  },
  maxTMS: {
    NOVIDADES: '133988940',
    DICAS: '133988962',
    RELEASE_NOTES: '133988964',
    WEBINAR: '133988946',
    COMUNICADOS: '133988952',
    CONTEUDO: '133988970',
    OFERTAS: '133988972'
  }
};
